export default __webpack_public_path__ + "static/media/AddToPlaylist.91b19dc6.svg";